var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 42,
    viewBox: "0 0 42 42",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    fill: "#ffab00",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    fill: "#ffab00",
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    transform: "translate(-1091.283 -2037.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1112.283 2065.289v-.949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1112.283 2060.978v-.971c0-3.557 4-3.3 4-6.047 0-4.125-8-4.031-8-.451"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.969f4804f1ecda8f6760636702f96db0.svg";
export { ForwardRef as ReactComponent };